editTemplateElementController.$inject = [
                                         '$scope', 
                                         '$uibModalInstance', 
                                         '$translate',
                                         'QuickRepliesFactory',
                                         'MediasFactory', 
                                         'companyId', 
                                         'siteId', 
                                         'AlertingFactory', 
                                         'templateType',
                                         'element',
                                         'modalTitle',
                                         'showRemoveButton',
                                         'showCompactCheckbox'];
export function editTemplateElementController(
                                              $scope, 
                                              $uibModalInstance, 
                                              $translate,
                                              QuickRepliesFactory,
                                              MediasFactory, 
                                              companyId, 
                                              siteId, 
                                              AlertingFactory, 
                                              templateType,
                                              element, 
                                              modalTitle,
                                              showRemoveButton,
                                              showCompactCheckbox) {
  $scope.submit = submit;
  $scope.cancel = cancel;
  $scope.deleteItem = deleteItem;
  $scope.removePicture = removePicture;
  $scope.removeVideo = removeVideo;
  $scope.isSubmitBtnEnabled = isSubmitBtnEnabled;

  init();

  function submit() {
    if (!$scope.element.has_default_action) {
      delete $scope.element.default_action;
    }
    delete $scope.element.has_default_action;
    if (!$scope.element.has_button) {
      delete $scope.element.button;
    } else {
      QuickRepliesFactory.cleanupButtonPayload($scope.element.button);
    }
    delete $scope.element.has_button;
    $uibModalInstance.close({type: 'edit', element: $scope.element});
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }

  function deleteItem() {
    $uibModalInstance.close({type: 'delete'});
  }

  function removePicture() {
    delete $scope.element.pictureId;
    updateMediaUrls();
  }

  function removeVideo() {
    delete $scope.element.videoId;
    updateMediaUrls();
  }

  function updateMediaUrls() {
    if (typeof element.pictureId === 'number') {
      MediasFactory.pictureUrlWithJWT(companyId, element.pictureId).then((urlWithJwt) => {
        $scope.bgImage = `url("${urlWithJwt}")`;
      });
    } else {
      $scope.bgImage = 'none';
    }
    if (typeof element.videoId === 'number') {
      $scope.videoUrl = MediasFactory.videoUrl(companyId, element.videoId);
    } else {
      $scope.videoUrl = '';
    }
  }

  function uploadImage(file) {
    $scope.loading = true;
    uploadMedia(file, 'image', data => $scope.element.pictureId = data.media_id);
  }

  function uploadVideo(file) {
    $scope.loading = true;
    uploadMedia(file, 'video', data => $scope.element.videoId = data.media_id);
  }

  function uploadMedia(file, type, success) {
    MediasFactory.upload2(companyId, siteId, type, file, 
                          response => {
                            success(response.data);
                            $scope.loading = false;
                            updateMediaUrls();
                          },
                          response => {
                            $scope.loading = false;
                            AlertingFactory.error(response.data.error);
                          });
  }

  // Check if first item in messenger list is either compact without picture or not compact with picture 
  // and if all messenger list items have at least image or subtitle set
  function isSubmitBtnEnabled() {
    switch(templateType) {
      case 'html.MessengerListItem':
        if (!showCompactCheckbox) {
          return element.subtitle || element.pictureId;
        }
        else {
          return (element.compact && !element.pictureId || !element.compact && element.pictureId) && (element.subtitle || element.pictureId);
        }
      case 'html.BZCRichLinkAManoBox':
      case 'editor2-bzcRichLink':
         return element.pictureId || element.videoId;
      default:
        return true;
    }
  }

  function init() {
    $scope.element = element;
    $scope.templateType = templateType;
    $scope.fileNames = {};
    $scope.modalTitle = modalTitle;
    $scope.showRemoveButton = showRemoveButton;
    $scope.showCompactCheckbox = showCompactCheckbox;
    switch (templateType) {
      case 'html.MessengerGenericTemplateAManoBox':
        $scope.canHavePicture = true;
        $scope.canHaveVideo = false;
        $scope.canHaveVideoPreview = false;
        $scope.canHaveTitle = true;
        $scope.canHaveSubtitle = true;
        $scope.canHaveText = false;
        $scope.canHaveURL = false;
        $scope.canHaveDefaultAction = true;
        $scope.canHaveButton = false;
        break;
      case 'html.MessengerMediaTemplateAManoBox':
        $scope.canHavePicture = true;
        $scope.canHaveVideo = true;
        $scope.canHaveVideoPreview = false;
        $scope.canHaveTitle = false;
        $scope.canHaveSubtitle = false;
        $scope.canHaveText = false;
        $scope.canHaveURL = false;
        $scope.canHaveDefaultAction = false;
        $scope.canHaveButton = false;
        break;
      case 'html.MessengerButtonTemplateAManoBox':
        $scope.canHavePicture = false;
        $scope.canHaveVideo = false;
        $scope.canHaveVideoPreview = false;
        $scope.canHaveTitle = false;
        $scope.canHaveSubtitle = false;
        $scope.canHaveText = true;
        $scope.canHaveURL = false;
        $scope.canHaveDefaultAction = false;
        $scope.canHaveButton = false;
        break;
      case 'html.MessengerListItem':
        $scope.canHavePicture = true;
        $scope.canHaveVideo = false;
        $scope.canHaveVideoPreview = false;
        $scope.canHaveTitle = true;
        $scope.canHaveSubtitle = true;
        $scope.canHaveText = false;
        $scope.canHaveURL = false;
        $scope.canHaveDefaultAction = true;
        $scope.canHaveButton = true;
        break;
      case 'html.BZCRichLinkAManoBox':
      case 'editor2-bzcRichLink':
        $scope.canHavePicture = true;
        $scope.canHaveVideo = true;
        $scope.canHaveVideoPreview = true;
        $scope.canHaveTitle = true;
        $scope.canHaveSubtitle = false;
        $scope.canHaveText = false;
        $scope.canHaveURL = true;
        $scope.canHaveDefaultAction = false;
        $scope.canHaveButton = false;
        break;

    }
    $scope.loading = false;
    $scope.pictureFile = null;
    updateMediaUrls();
    $scope.$watch('fileNames.picture', function(newFile) {
      if (newFile) {
        uploadImage(newFile);
      }
    });
    $scope.$watch('fileNames.video', function(newFile) {
      if (newFile) {
        uploadVideo(newFile);
      }
    });
    $scope.element.has_default_action = !!$scope.element.default_action;
    $scope.element.has_button = !!$scope.element.button;
  }

}
